import React from "react";

import LeftSidebar from "../../../components/Layouts/Sidebar/LeftSidebar";
import RightSidebar from "../../../components/Layouts/Sidebar/RightSidebar";

import Post from "../../../Screen/Post/Post";

import NestedSubCategory from "./NestedSubCategory/NestedSubCategory";
import PromoVideo from "./../../PromoVideo/PromoVideo";
import Navigation from "../../Layouts/Header/Navigation";

const NestedSubCategoryBody = () => {
  return (
    <React.Fragment>
      <Navigation />
      <div className="homebody ">
        <div className="container-fluid custom-container ">
          <div className="row">
            <div className="col-sm-3 justify-content-center container-fluid custom-container-left-Right postLeft">
              <div className="promoVideoBorder">
                <PromoVideo />
              </div>

              <LeftSidebar />
            </div>

            <div className="col-sm-6 justify-content-center postTab ">
              <NestedSubCategory />
              <Post />
            </div>

            <div className="col-md-3 justify-content-center container-fluid custom-container-left-Right postRight">
              <RightSidebar />
            </div>
          </div>
        </div>
      </div>
      <br />
    </React.Fragment>
  );
};

export default NestedSubCategoryBody;
